<template>
    <div class="gallery-overlay">
        <div class="gallery-overlay--outer-wrapper">
            <button class="gallery-overlay--btn btn btn__secondary btn__square btn__medium" @click="onClose">
                <div class="swiper-gallery--btn-content btn--wrap">
                    <ui-icon symbol="close" size="medium"/>
                </div>
            </button>

            <div class="gallery-overlay--inner-wrapper">
                <swiper-gallery class="gallery-overlay--element"
                        :allow-overlay="false"
                        :initial-idx="imageIdx"
                        :images="images"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import SwiperGallery from 'framework/global-components/swiper-gallery/swiper-gallery';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';

    export default {
        components: {
            SwiperGallery,
            UiIcon,
        },
        mixins: [
            bemMixin('gallery-overlay'),
        ],
        props: {
            imageIdx: {
                type: Number,
                required: true,
            },
            /** @type IImageSet[] */
            images: {
                type: Array,
                required: true,
            },
        },
        methods: {
            ...mapActions('project-status', ['toggleGalleryOverlay']),
            onClose() {
                this.toggleGalleryOverlay({ open: false });
            },
        },
    };
</script>
